"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClayPaginationBarWithBasicItems = void 0;
var _button = _interopRequireDefault(require("@clayui/button"));
var _core = require("@clayui/core");
var _icon = _interopRequireDefault(require("@clayui/icon"));
var _pagination = require("@clayui/pagination");
var _shared = require("@clayui/shared");
var _react = _interopRequireWildcard(require("react"));
var _PaginationBar = require("./PaginationBar");
var _excluded = ["activeDelta", "labels", "spritemap"],
  _excluded2 = ["active", "activeDelta", "activePage", "alignmentPosition", "defaultActive", "deltas", "disabledPages", "disableEllipsis", "ellipsisBuffer", "ellipsisProps", "hrefConstructor", "labels", "onActiveChange", "onDeltaChange", "onPageChange", "showDeltasDropDown", "spritemap", "totalItems"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var defaultDeltas = [{
  label: 10
}, {
  label: 20
}, {
  label: 30
}, {
  label: 50
}];
var DEFAULT_LABELS = {
  itemsPerPagePickerAriaLabel: 'Items Per Page',
  paginationResults: 'Showing {0} to {1} of {2}',
  perPageItems: '{0} items',
  selectPerPageItems: '{0} items'
};
var Trigger = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var activeDelta = _ref.activeDelta,
    labels = _ref.labels,
    spritemap = _ref.spritemap,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_button.default, _extends({}, otherProps, {
    className: "dropdown-toggle",
    displayType: "unstyled",
    ref: ref
  }), (0, _shared.sub)(labels.perPageItems, [activeDelta]), /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: "caret-double-l"
  }));
});
Trigger.displayName = 'Trigger';
var ClayPaginationBarWithBasicItems = exports.ClayPaginationBarWithBasicItems = function ClayPaginationBarWithBasicItems(_ref2) {
  var active = _ref2.active,
    activeDelta = _ref2.activeDelta,
    activePage = _ref2.activePage,
    alignmentPosition = _ref2.alignmentPosition,
    _ref2$defaultActive = _ref2.defaultActive,
    defaultActive = _ref2$defaultActive === void 0 ? 1 : _ref2$defaultActive,
    _ref2$deltas = _ref2.deltas,
    deltas = _ref2$deltas === void 0 ? defaultDeltas : _ref2$deltas,
    disabledPages = _ref2.disabledPages,
    _ref2$disableEllipsis = _ref2.disableEllipsis,
    disableEllipsis = _ref2$disableEllipsis === void 0 ? false : _ref2$disableEllipsis,
    ellipsisBuffer = _ref2.ellipsisBuffer,
    ellipsisProps = _ref2.ellipsisProps,
    hrefConstructor = _ref2.hrefConstructor,
    _ref2$labels = _ref2.labels,
    labels = _ref2$labels === void 0 ? DEFAULT_LABELS : _ref2$labels,
    onActiveChange = _ref2.onActiveChange,
    onDeltaChange = _ref2.onDeltaChange,
    onPageChange = _ref2.onPageChange,
    _ref2$showDeltasDropD = _ref2.showDeltasDropDown,
    showDeltasDropDown = _ref2$showDeltasDropD === void 0 ? true : _ref2$showDeltasDropD,
    spritemap = _ref2.spritemap,
    totalItems = _ref2.totalItems,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  if (totalItems === 0) {
    totalItems = 1;
  }
  var _useControlledState = (0, _shared.useControlledState)({
      defaultName: 'defaultActive',
      defaultValue: defaultActive,
      handleName: 'onActiveChange',
      name: 'value',
      onChange: onActiveChange !== null && onActiveChange !== void 0 ? onActiveChange : onPageChange,
      value: typeof active === 'undefined' ? activePage : active
    }),
    _useControlledState2 = _slicedToArray(_useControlledState, 2),
    internalActive = _useControlledState2[0],
    setActive = _useControlledState2[1];
  labels = _objectSpread(_objectSpread({}, DEFAULT_LABELS), labels);
  if (!activeDelta) {
    activeDelta = deltas[0].label;
  }
  var totalPages = Math.ceil(totalItems / activeDelta);
  (0, _react.useEffect)(function () {
    if (internalActive > totalPages) {
      setActive(1);
    }
  }, [totalPages]);
  var ariaDescribedby = (0, _shared.useId)();
  return /*#__PURE__*/_react.default.createElement(_PaginationBar.PaginationBar, otherProps, showDeltasDropDown && /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown pagination-items-per-page"
  }, /*#__PURE__*/_react.default.createElement(_core.Picker, {
    activeDelta: activeDelta,
    "aria-describedby": ariaDescribedby,
    "aria-label": labels.itemsPerPagePickerAriaLabel,
    as: Trigger,
    items: deltas,
    labels: labels,
    onSelectionChange: function onSelectionChange(key) {
      return onDeltaChange && onDeltaChange(Number(key));
    },
    selectedKey: String(activeDelta),
    spritemap: spritemap
  }, function (item) {
    return /*#__PURE__*/_react.default.createElement(_core.Option, {
      href: item.href,
      key: item.label
    }, (0, _shared.sub)(labels.selectPerPageItems, [String(item.label)]));
  })), /*#__PURE__*/_react.default.createElement(_PaginationBar.PaginationBar.Results, {
    id: ariaDescribedby
  }, (0, _shared.sub)(labels.paginationResults, [(internalActive - 1) * activeDelta + 1, internalActive * activeDelta < totalItems ? internalActive * activeDelta : totalItems, totalItems])), /*#__PURE__*/_react.default.createElement(_pagination.ClayPaginationWithBasicItems, {
    active: internalActive,
    alignmentPosition: alignmentPosition,
    disableEllipsis: disableEllipsis,
    disabledPages: disabledPages,
    ellipsisBuffer: ellipsisBuffer,
    ellipsisProps: ellipsisProps,
    hrefConstructor: hrefConstructor,
    onActiveChange: setActive,
    spritemap: spritemap,
    totalPages: totalPages
  }));
};